import { Card } from 'dash-ui';
import styled from 'styled-components';

export const DownloadedFilesChartWraper = styled(Card)`
  @media ${({ theme }) => theme.devices.mobile} {
    margin-bottom: 25px;
  }
`;
